import React from "react";
import { useSocket } from "common/hooks/useSocket";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import ConfirmDialog from "common/components/ConfirmDialog";

type PauseDraftProps = {
  open: boolean;
};

const PauseDraft = (props: PauseDraftProps) => {
  const { open } = props;
  const { t } = useTranslation();
  const socket = useSocket();
  const navigate = useNavigate();

  return (
    <ConfirmDialog
      open={open}
      title={t("Draft en pause")}
      description={t(
        "Un ou plusieurs joueurs ont quitté la draft. En attente de reconnexion...",
      )}
      showCancel={false}
      onConfirm={() => {
        socket.emit("send-leave-room");
        navigate("/");
      }}
      confirmLabel={t("Quitter la draft")}
    />
  );
};

export default PauseDraft;
